module.exports = __webpack_public_path__ + "img/default-image.5f63444f.png";